


(function ($) {

  jQuery(document).ready(function () {
    $('.ten .article').each(function () {
      var blog_title = $(this).find('h3').html();
      $(this).find('h3').remove();
      $(this).find('.title_content p').last().prepend("<h3>" + blog_title + "</h3>")
    });

    setTimeout(function(){
      $("#content_bg > limespot > limespot-container > limespot-box > div > div.ls-ul-container.limespot-recommendation-box-carousel.v-align > ul > li > a > div.ls-info-wrap > div.ls-title").each(function () {
        if ($(this).html().indexOf('Customize') > -1) {
          $(this).parents('.limespot-recommendation-box-item').remove()
        }
      })
    }, 4000)

  });


  var menuToHeight = $('#nav').offset().top;
  $(window).scroll(function () {

    var annHeight = $('#spb-information-bar').height();
    var annHeightPx = annHeight + 'px';
    var topScroll = $(this).scrollTop();

    if (topScroll > menuToHeight) {
      $('body').addClass('sticky_nav');
    } else {
      $('body').removeClass('sticky_nav');
    }

    if (annHeight > 3) {
      $('.sticky_nav #nav').css("top", annHeightPx);
    }
  });

})(jQuery);


$(document).ready(function(){
  $('.btm_logos .customer-logos').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 2
      }
    }]
  });
});



$(document).ready(function(){
  function resize() {
    if(screen.width<480){
      let marginLeft = document.querySelector("#content_bg > div.sixteen.columns.logo > div.seven.columns.logo-right").getBoundingClientRect().x
      $('#content_bg > div.sixteen.columns.logo').attr("style", `width:100vw!important;margin-left:-${marginLeft}px`)
    }
  }

  window.onresize = resize
  resize();
  
//   setTimeout(function(){
//     if(window.innerWidth<768){
//       const topBarHeight = document.querySelector("#spb-information-bar").clientHeight
//       document.querySelector("#main_bg > div.top_bar").setAttribute('style',`top:${topBarHeight}px`)
//       document.querySelector("#mobile_nav").setAttribute('style',`margin-top:${topBarHeight+15}px!important`)
//       document.querySelector(".slicknav_menu .slicknav_nav").setAttribute('style',`padding-top:${topBarHeight}px!important`)
//     }
//   },3000)

});


// $(document).ready(function(){
//   const hideSwatchesList = [
//     "Seller","Designer","Themes", "home-tab"
//   ]
//   const filterCollection =()=> document.querySelectorAll('body.snize-results-page .snize-product-filters-list li').forEach((e) => {
//     let link = jQuery(e).find('input').val()
//     let hideSwatch = false
//     hideSwatchesList.map(i => (link && link.indexOf(i)>-1) && (hideSwatch = true))
//     hideSwatch && jQuery(e).hide()
//   })
  
//   setTimeout(()=>filterCollection(), 4000)

//   document.querySelectorAll('body.snize-results-page .snize-product-filters-list li .needsclick').forEach((e) => {
//       jQuery(e).click(function(){
//           setTimeout(()=>filterCollection(), 3000)
//           console.log(333333)
//       })
//   })
// })

window.onload = ()=>{
  if(document.location.pathname.includes('pages/aj-designer') && screen.width<480){
    document.body.classList.add('mv_designer_page')
    
    document.querySelectorAll('.tab-content').forEach((i)=>{
      i.classList.add('mv_col_content')
    })
  
    document.querySelectorAll('.tab-content .one-third').forEach((i)=>{
    i.classList.add('four')
      i.classList.add('columns')
    })
  }
}